import { techniqueConstants } from "../constants/techniques.constants";
import { techniquesService } from "../services";

export const techniqueActions = {
    getTechniques
}

function getTechniques(filters, page, pageSize, cancelToken) {
  return (dispatch) => {
    dispatch({ type: techniqueConstants.TECHNIQUES_LOADING });

    return techniquesService.getTechniques(filters, page, pageSize, cancelToken)
      .then((data) => {
        dispatch({
          type: techniqueConstants.TECHNIQUES_LOAD_SUCCESS,
          payload: data,
        });
        
        return data;
      })
      .catch((err) => {
        dispatch({ type: techniqueConstants.TECHNIQUES_LOAD_ERROR });
        throw err;
      });
  };
}
